/* Full-store sampling. Existing card markup and carousel handlers stay in charge. */
(() => {
  if (window.NorgiraRandomRecommendations) return;
  const shuffle = values => {
    const result = [...values];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };
  const populate = async root => {
    if (root.dataset.randomReady || root.dataset.randomLoading) return;
    root.dataset.randomLoading = 'true';
    const track = root.querySelector('.product-grid,.ncd-recommendations__track');
    const initial = root.querySelector('template[data-random-product-pool]');
    if (!track || !initial) { delete root.dataset.randomLoading; return; }
    const pool = [...initial.content.children];
    const pages = new Set();
    let next = initial.dataset.nextUrl;
    try {
      while (next) {
        const url = new URL(next, location.href);
        if (url.origin !== location.origin || pages.has(url.href)) break;
        pages.add(url.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Random recommendation pool unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pageRoot = doc.querySelector(root.localName);
        const template = pageRoot?.querySelector('template[data-random-product-pool]');
        if (!template) throw new Error('Random recommendation page missing');
        pool.push(...template.content.children);
        next = template.dataset.nextUrl;
      }
    } catch (_) {
      root.dataset.randomPartial = 'true';
    }
    if (!root.isConnected) return;
    let cartIds = [];
    try { cartIds = JSON.parse(root.dataset.excludeProductIds || '[]'); } catch (_) {}
    const currentId = root.dataset.productId || document.querySelector('norgira-random-recommendations[data-product-id]')?.dataset.productId;
    const excluded = new Set([...cartIds.map(String), String(currentId || '')]);
    const seen = new Set();
    const candidates = pool.filter(card => {
      const id = card.dataset.randomProductId;
      if (!id || seen.has(id) || excluded.has(id)) return false;
      seen.add(id);
      return true;
    });
    const limit = Math.max(1, Number(root.dataset.randomLimit) || 8);
    const selected = shuffle(candidates).slice(0, limit);
    track.replaceChildren(...selected);
    track.scrollLeft = 0;
    root.dataset.randomPoolSize = String(candidates.length);
    root.dataset.randomSelectedIds = selected.map(card => card.dataset.randomProductId).join(',');
    root.dataset.randomReady = 'true';
    delete root.dataset.randomLoading;
    root.classList.toggle('product-recommendations--loaded', selected.length > 0);
    root.hidden = selected.length === 0;
    track.dispatchEvent(new Event('scroll'));
    root.dispatchEvent(new CustomEvent('norgira:recommendations-ready', { bubbles: true }));
    root.updateButtons?.();
  };
  window.NorgiraRandomRecommendations = { populate, shuffle };
  if (!customElements.get('norgira-random-recommendations')) {
    customElements.define('norgira-random-recommendations', class extends HTMLElement {
      connectedCallback() { populate(this); }
    });
  }
})();
